import { Loader2 } from 'lucide-react';

import { cn } from '../../components/ui/utils';

/**
 * «Обновляем» для фонового запроса: данные на экране уже есть и остаются на
 * месте, поэтому спиннер во весь блок был бы враньём — подменять готовое
 * пустотой ради индикации нечестно.
 */
export function RefreshingHint({
  active,
  className,
  children = 'Обновляем…',
}: {
  active: boolean;
  className?: string;
  children?: string;
}): JSX.Element {
  return (
    <span
      aria-live="polite"
      className={cn(
        'inline-flex items-center gap-1.5 text-xs text-muted-foreground transition-opacity duration-300 motion-reduce:transition-none',
        active ? 'opacity-100' : 'opacity-0',
        className,
      )}
    >
      <Loader2 className="size-3 animate-spin" />
      {active ? children : ''}
    </span>
  );
}
